import styled from 'styled-components';

export const FormattedDraggableTable = styled.div.attrs<{ leftMargin?: number; paddingLeft?: number }>({
	className: 'tws-formatted-draggable-table',
	'data-testid': 'tws-formatted-draggable-table',
})<{ leftMargin?: number; paddingLeft?: number }>`
	padding-left: ${(props) => (props.paddingLeft !== undefined ? props.paddingLeft + 'px' : '0px')};
	overflow: visible;
	.ui-sortable-helper {
		left: ${(props) => (props.leftMargin != null ? props.leftMargin + '' : '30')}px !important;
		margin-right: 0px;
		margin-left: 20px;
	}
`;

const lastChildWidth = (pageFlowElementsExist?: boolean): string => {
	return pageFlowElementsExist
		? `
			width: 77px;
			min-width: 72px;
		`
		: `
			min-width: 24px;
			width: 24px;
		`;
};

export const FormattedDraggableHeaderRow = styled.div.attrs<{ pageFlowElementsExist?: boolean }>({
	className: 'tws-formatted-design-header-row',
	'data-testid': 'tws-formatted-design-header-row',
})<{ pageFlowElementsExist?: boolean }>`
	padding-bottom: 10px;
	min-width: 500px;
	display: flex;
	> :first-child {
		min-width: 30px;
		width: 30px;
	}
	> :nth-child(2) {
		padding-left: 30px;
	}
	> :last-child {
		${(props) => lastChildWidth(props.pageFlowElementsExist)}
	}
`;

export const FormattedDraggableTh = styled.div.attrs<{ flexBasis: number; rightAlign?: boolean }>({
	className: 'tws-formatted-draggable-th',
})<{ flexBasis: number; rightAlign?: boolean }>`
	font-size: 11px;
	font-weight: 700;
	color: #444444;
	line-height: 1.1em;
	text-transform: uppercase;
	flex: 1 1 ${(props) => props.flexBasis}%;
	${(props) => (props.rightAlign ? 'text-align: right;' : '')}
`;

const lastChildLeftBorder = (hideLeftBorder?: boolean): string => {
	return hideLeftBorder
		? ''
		: `
		border-left: 10px solid rgb(40,171,201);
		border-bottom-left-radius: 4px;
		border-top-left-radius: 4px;
	`;
};
export const FormattedDesignTableRow = styled.div.attrs<{ hideLeftBorder?: boolean }>({
	className: 'tws-formatted-design-table-row',
})<{ hideLeftBorder?: boolean }>`
	margin-bottom: 10px;
	margin-right: 0px;
	min-width: 500px;
	position: relative;

	display: flex;

	> :first-child {
		${(props) => lastChildLeftBorder(props.hideLeftBorder)}
		padding-left: 30px !important;
	}
`;

export const FormattedDesignTd = styled.div<{ flexBasis: number; rightAlign?: boolean }>`
	background-color: rgb(237, 244, 247);
	padding: 25px 30px 25px 0;
	font-size: 13.5px;
	font-weight: 500;
	vertical-align: middle;
	word-break: break-word;
	text-align: left;
	color: rgb(105, 105, 105);
	justify-content: center;
	flex-direction: column;
	display: flex;
	flex: 1 1 ${(props) => props.flexBasis}%;
	${(props) => (props.rightAlign ? 'align-items: flex-end;' : '')}
`;

const dragHandleCSS = (isDisabled?: boolean): string => {
	return isDisabled
		? `
		.draggable-handle {
			background-color: #999999;
			cursor: default;
		}`
		: '';
};
export const FormattedDesignTBodyContainer = styled.div<{ isDisabled?: boolean }>`
	${(props) => dragHandleCSS(props.isDisabled)}
`;
